<script lang="ts">
  import '../../../../app.postcss'
  import Button from '$lib/components/shadcn/button/button.svelte'
  import ButtonArrowUpSvg from '../../components/SVGs/ButtonArrowUpSVG.svelte'
</script>

<section class="hidden lg-desktop:flex lg-desktop:h-[450px] lg-desktop:items-center lg-desktop:justify-center">
  <div class="flex flex-col items-center">
    <h2 class="w-[450px] text-center font-cirka text-[76px] leading-[65px]">Join our dynamic team</h2>
    <p class="w-[580px] py-8 font-graphik text-[20px]">
      We would love to hear from you if you’re passionate about the industry and think you can add something we’re
      missing.
    </p>
    <Button
      variant="ghost"
      href="mailto:admin@butane.dev"
      class="flex h-[46px] w-[173px] items-center justify-evenly rounded-full bg-white uppercase text-black shadow-sm shadow-[#939EB8] transition-all duration-300 hover:scale-[1.01] hover:bg-white/80 hover:text-black active:scale-[.99]"
    >
      <p class="mr-2 font-graphik">Contact Us</p>
      <ButtonArrowUpSvg fillStyles="#000" />
    </Button>
  </div>
</section>
